var _style, _circle, _circle2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgInterests = function SvgInterests(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    id: "interests_svg__Light",
    x: 0,
    y: 0,
    viewBox: "0 0 24 24"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".interests_svg__st0{fill:none;stroke:#000;stroke-linecap:round;stroke-linejoin:round}")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 3,
    r: 2.5,
    className: "interests_svg__st0"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 5.5,
    cy: 21.5,
    r: 2,
    className: "interests_svg__st0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m10.8 17.6.7-3.5M19.4 3.5c-.8-.2-1.6.3-1.8 1.1l-.2 1C17 6.7 16 7.5 14.9 7.5H9.6c-2.5 0-4.7 1.7-5.3 4.2l-.2 1c-.2.8.3 1.6 1.1 1.8h.4c.7 0 1.3-.5 1.5-1.1l.2-1c.3-1.1 1.3-1.9 2.4-1.9h.1l-1.3 6.6c-.1.7.3 1.3 1 1.5s1.3-.3 1.5-1q0 0 0 0h0L9.9 22c-.1.7.3 1.3 1 1.5.7.1 1.3-.3 1.5-1h0l2.4-12h.1c2.5 0 4.7-1.7 5.3-4.2l.2-1c.3-.7-.2-1.6-1-1.8",
    className: "interests_svg__st0"
  })));
};
export default SvgInterests;